import { useEffect, useRef, useState } from "react";
import {
  FaPlay,
  FaPause,
  FaForwardStep,
  FaBackwardStep,
} from "react-icons/fa6";
import { SpotifyPlayerInfo } from "../WeddingInfo/WeddingInfo";

interface SpotifyPlayerProps {
  player: SpotifyPlayerInfo;
}

const SpotifyPlayer: React.FC<SpotifyPlayerProps> = ({ player }) => {
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [progress, setProgress] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);

  const togglePlay = () => {
    if (videoRef.current && audioRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
        // audioRef.current.pause();
      } else {
        videoRef.current.play();
        // audioRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const formatTime = (seconds: number): string => {
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins.toString().padStart(2, "0")}:${secs
      .toString()
      .padStart(2, "0")}`;
  };

  // 재생 진행률 추적
  useEffect(() => {
    let animationFrameId: number;

    const updateProgress = () => {
      if (videoRef.current) {
        const current = videoRef.current.currentTime;
        const total = videoRef.current.duration || 1;
        const percent = (current / total) * 100;

        setProgress(percent);
        setCurrentTime(current);
        setDuration(total);

        animationFrameId = requestAnimationFrame(updateProgress);
      }
    };

    if (isPlaying) {
      animationFrameId = requestAnimationFrame(updateProgress);
    }

    return () => cancelAnimationFrame(animationFrameId);
  }, [isPlaying]);

  return (
    <div className="flex flex-col text-white">
      {/* 비디오 화면 */}
      <div className="flex items-center space-x-2 mt-8 mb-6 mx-4">
        <div className="text-white font-bold">{player.sectionTitle}</div>
      </div>

      <div className="flex justify-center -mt-2">
        <div className="relative mx-12 bg-gray-900 rounded-xl overflow-hidden">
          <video
            ref={videoRef}
            className="w-full h-full object-cover aspect-[1]"
            src={player.videoURL}
            onLoadedMetadata={() => {
              if (videoRef.current) {
                setDuration(videoRef.current.duration);
              }
            }}
            onEnded={() => {
              setIsPlaying(false); // 플레이 상태 false로 변경
              if (videoRef.current) {
                videoRef.current.currentTime = 0; // 원하면 영상도 처음으로
              }
            }}
          />
        </div>
      </div>

      {/* 오디오 태그 */}
      <audio
        ref={audioRef}
        src={`${process.env.PUBLIC_URL}/who-do-you-love-me.mp3`}
      />

      {/* 곡 정보 */}
      <div className="mt-4 text-left mx-12">
        <h2 className="text-xl font-semibold">{player.title}</h2>
        <p className="text-gray-400">{player.caption}</p>
      </div>

      {/* 진행 바 */}
      <div className="max-w-md mt-6 mx-12">
        <div className="flex justify-between text-sm text-gray-400">
          <span>{formatTime(currentTime)}</span>
          <span>{formatTime(duration)}</span>
        </div>
        <div className="w-full h-1 bg-gray-700 rounded-md mt-1">
          <div
            className="h-1 bg-white rounded-md transition-all duration-150"
            style={{ width: `${progress}%` }}
          ></div>
        </div>
      </div>

      {/* 컨트롤 버튼 */}
      <div className="mt-6 flex items-center justify-center space-x-6 mb-6">
        <button className="text-xl text-white">
          <FaBackwardStep />
        </button>

        <button
          onClick={togglePlay}
          className="w-12 h-12 bg-white text-black rounded-full flex items-center justify-center"
        >
          {isPlaying ? (
            <FaPause className="text-2xl" />
          ) : (
            <FaPlay className="text-2xl" />
          )}
        </button>

        <button className="text-xl text-white">
          <FaForwardStep />
        </button>
      </div>
    </div>
  );
};

export default SpotifyPlayer;
